import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { CustomTargetEffects } from './+store/data/effects';
import { CUSTOM_TARGET_LOCALIZATION_SCOPE } from './constants';
import { CustomTargetRepository } from './repositories/custom-target.repository';

@NgModule({
  imports: [
    EffectsModule.forFeature([CustomTargetEffects]),
    CommonLocalizationModule.forFeature(CUSTOM_TARGET_LOCALIZATION_SCOPE)
  ],
  providers: [CustomTargetRepository]
})
export class CustomTargetModule {}
